import './Filter.scss';
import React, { useState } from 'react';
import { GET_ALL_CARRIERS_FILTER, GET_ALL_REGIONS } from '../../graphql/client/queries';
import { GetAllCarriersFilter, GetAllRegions } from '../../types/schemaTypes';
import { useStoreContext } from '../App/StoreProvider';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import Button from 'react-bootstrap/Button';
import { useQuery } from '@apollo/client/react';
import FilterItem from './FilterItem';
import * as LoadManagementListActions from '../../store/actions/loadManagementList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LoadFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DriverFilters = ({ abortRequest, onFilterToggle, showFilter, setShowFilter }: LoadFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [state] = useStoreContext();
    const [, dispatch] = useStoreContext();

    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);

    const carrierFilters = (carriersData?.getAllCarriersFilter ?? []).filter((c) => c != null);
    const loadStatuses: any = [];
    const districtFilters: { id: number; name: string }[] = [];
    const regionFilters: { id: number; name: string }[] = [];

    const statusFilters: FilterItem[] = [
        { id: 1, name: 'Active' },
        { id: 2, name: 'Inactive' },
    ];

    const compliantStatusFilters: FilterItem[] = [
        { id: 1, name: 'Compliant' },
        { id: 2, name: 'Not Compliant' },
    ];

    const availabilityFilters: FilterItem[] = [
        { id: 1, name: 'Yes' },
        { id: 2, name: 'No' },
    ];

    const bellyDumpFilters: FilterItem[] = [
        { id: 1, name: 'Hopper' },
        { id: 2, name: 'Box' },
    ];

    const onSelectCompliatntStatus = (value: number) => {
        dispatch(LoadManagementListActions.setFiltersForLoads('CompliantStatus', value, true));
    };

    const onSelectAvailability = (value: number) => {
        dispatch(LoadManagementListActions.setFiltersForLoads('IsAvailable', value, true));
    };

    const onSelectBellyDump = (value: number) => {
        dispatch(LoadManagementListActions.setFiltersForLoads('CheckInWithBellyDump', value, true));
    };

    const {
        loadManagementList: {
            searchPhraseSubset: { regionSubset, districtSubset, carrierSubset, statusSubset },
        },
    } = state;
    // loadStatuses.push({
    //     id: 1,
    //     name: 'Active',
    // });
    // loadStatuses.push({
    //     id: 0,
    //     name: 'Inactive',
    // });

    const onSelectStatus = value => {
        dispatch(LoadManagementListActions.setFiltersForLoads('Status', value, true));
    };

    if (regionsData?.getAllRegions) {
        (regionsData.getAllRegions ?? []).forEach((item) => {
            if (item == null) return;
            regionFilters.push({
                id: item.id,
                name: item.regionName ?? '',
            });
            (item.districts ?? []).forEach((district) => {
                if (district == null) return;
                districtFilters.push({
                    id: district.id,
                    name: district.districtName ?? '',
                });
            });
        });
    }

    return (
        <div className={
            showFilter
                ? 'DriverFilter-FiltersContainer Job-FiltersContainer'
                : 'DriverFilter-FiltersContainer Job-FiltersContainer DriverFilter-hide'
        }>
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <Button
                        className="Filter-SelectAll"
                        variant="link"
                        onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                    >
                        {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                    </Button>
                    <FontAwesomeIcon
                        icon={['fas', 'times-circle']}
                        className="JobLoads-Filter"
                        onClick={() => setShowFilter(!showFilter)}
                    />
                </div>
                {/* <LoadFilterItem
                abortRequest={abortRequest}
                title="Load Status"
                items={loadStatuses}
                itemsSubset={statusSubset.subset}
                searchPhrase={statusSubset.searchPhrase}
                activeKey={activeKey}
                isCollection={true}
                isSearchable={false}
                loadManagementMode={true}
                onFilterToggle={onFilterToggle}
            /> */}
                <FilterItem
                    abortRequest={abortRequest}
                    title="Status"
                    items={statusFilters}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={false}
                    type="selectDropDown"
                    onSelection={onSelectStatus}
                    placeHolder="Filter By Status"
                />
                <FilterItem
                    abortRequest={abortRequest}
                    title="Compliant"
                    items={compliantStatusFilters}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={false}
                    type="selectDropDown"
                    onSelection={onSelectCompliatntStatus}
                    placeHolder="Filter By Compliant"
                />
                <FilterItem
                    abortRequest={abortRequest}
                    title="DNR"
                    items={availabilityFilters}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={false}
                    type="selectDropDown"
                    onSelection={onSelectAvailability}
                    placeHolder="Filter By DNR"
                />
                <FilterItem
                    abortRequest={abortRequest}
                    title="Hopper/Box"
                    items={bellyDumpFilters}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={false}
                    type="selectDropDown"
                    onSelection={onSelectBellyDump}
                    placeHolder="Filter By Hopper/Box"
                />

                <LoadFilterItem
                    abortRequest={abortRequest}
                    title="Region"
                    items={regionFilters}
                    itemsSubset={regionSubset.subset}
                    searchPhrase={regionSubset.searchPhrase}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={true}
                    loadManagementMode={true}
                    onFilterToggle={onFilterToggle}
                />
                <LoadFilterItem
                    abortRequest={abortRequest}
                    title="District"
                    items={districtFilters}
                    itemsSubset={districtSubset.subset}
                    searchPhrase={districtSubset.searchPhrase}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={true}
                    loadManagementMode={true}
                    onFilterToggle={onFilterToggle}
                />
                <LoadFilterItem
                    abortRequest={abortRequest}
                    title="Carrier"
                    items={carrierFilters}
                    itemsSubset={carrierSubset.subset}
                    searchPhrase={carrierSubset.searchPhrase}
                    activeKey={activeKey}
                    isCollection={true}
                    isSearchable={true}
                    loadManagementMode={true}
                    onFilterToggle={onFilterToggle}
                />
            </div>
        </div>
    );
};
